import { Window } from "@progress/kendo-react-dialogs";
import { If } from "../Common/UI/IfComponent";
import NewDataset from "../Datasets/NewDataset";
import { showDatasetCreationWindow } from "../Template/NewTemplateSignals";

export const DatasetCreationWindow = ({ handlePropertyChange }) => {
  return (
    <If condition={showDatasetCreationWindow.value}>
      <Window
        onClose={() => (showDatasetCreationWindow.value = false)}
        className="create-dataset-window"
        initialHeight={900}
        initialWidth={900}
        title={"New Dataset"}
      >
        <NewDataset
          dsetType={"List"}
          handlePropertyChange={handlePropertyChange}
          closeWindow={() => {
            showDatasetCreationWindow.value = false;
          }}
        />
      </Window>
    </If>
  );
};
